import React from 'react';
import { RiStarSFill, RiStarSLine } from 'react-icons/ri'; // Importing the star icons

const ReviewItem = ({ review }) => {
    // Calculate full, half, and empty stars for the review rating
    const fullStars = Math.floor(review.rating); // Calculate the full stars (e.g., 4 stars for a 4.5 rating)
    const halfStars = review.rating % 1 >= 0.5 ? 1 : 0; // Check if there's a half star
    const emptyStars = 5 - fullStars - halfStars; // Calculate the empty stars

    return (
        <div className="py-2 mb-5">
            <div className="flex flex-row text-2xl mb-2">
                {/* Display full, half, and empty stars dynamically */}
                {[...Array(fullStars)].map((_, index) => (
                    <RiStarSFill key={`full-${index}`} className="text-yellow-500" />
                ))}
                {halfStars > 0 && <RiStarSFill key="half" className="text-yellow-500 opacity-50" />} {/* Adjust opacity for half stars */}
                {[...Array(emptyStars)].map((_, index) => (
                    <RiStarSFill key={`empty-${index}`} className="text-gray-300" />
                ))}
            </div>
            <div className="font-semibold text-base my-1">
                {review.username} ({new Date(review.created_at).toLocaleString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true
                })})
            </div>

            <div className="text-gray-500 text-sm w-3/4">“{review.review}”</div>
        </div>
    );
};

export default ReviewItem;
